import type { Lead } from "@kanda-libs/ks-frontend-services";
import { capitaliseWords } from "common/helpers";
import { URLS } from "components/shared/App/constants";

export const getLeadStatusUrl = (status: Lead["status"] | ""): string =>
  [URLS.leads, status !== "" && status.replace(/_/g, "-")]
    .filter(Boolean)
    .join("/");

export const getLeadStatusFromUrl = (url: string): Lead["status"] | "" => {
  const formattedUrl = url.replace(URLS.leads, "");

  if (!formattedUrl) return "";

  return formattedUrl.replace("/", "").replace(/-/g, "_") as Lead["status"];
};

export const formatLeadStatus = (status: Lead["status"] | ""): string =>
  status === "" ? "All leads" : capitaliseWords(status.replace(/_/g, " "));

export const formatLeadSource = (source?: string): string =>
  source === ""
    ? "All sources"
    : capitaliseWords(source?.replace(/_/g, " ") || "");
